// @flow
import Cookies from 'js-cookie';

export class HttpError extends Error {
  statusCode: number;

  constructor(statusCode: number, message?: string) {
    super(message);
    this.statusCode = statusCode;
  }
}

function throwError(errorResponse: any): ?any {
  const { response: { status, statusText, body } = {} } = errorResponse;
  const { error, message } = body || {};

  if (status === 401 && window.location.pathname !== '/login' && window.location.pathname !== '/forgot-password') {
    window.location.href = '/login';
  }
  if (error) {
    throw new HttpError(status, error);
  }
  if (message) {
    throw new HttpError(status, message);
  }
  if (statusText) throw new HttpError(status, statusText);
  console.error('Error response:', errorResponse);
  throw new Error(errorResponse);
}

export default throwError;
